// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:47971c00-acbd-4d39-82ac-5de1e872936c",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_hrn5lTe2P",
    "aws_user_pools_web_client_id": "249jpu4igrqgm10h5or02u434g",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://rb6j7y3u5ba6dfq3ys7jq47ble.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "chatAPI",
            "endpoint": "https://xdoba6sl8f.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "chatKit-dev",
            "region": "us-east-1"
        }
    ],
    "aws_content_delivery_bucket": "gatsbychat-20191208232848-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d2wctpcwhddf2k.cloudfront.net"
};


export default awsmobile;
